import { $t } from '@/i18n';
export const CATEGORY = {
  UI: $t('k_9a34c9f8'),
  LOGIC: $t('k_de5ea61d'),
  DATASOURCE: $t('k_462caeed'),
  EXPORT: $t('k_d099f7e5'),
  NAVIGATOR: $t('k_3f834a96'),
  DRAFT: $t('k_1fbf2138'),
  NOTIFICATION: $t('k_ba87aead'),
  WORKFLOW: $t('k_93c10ead'),
  FLOW: $t('k_d379411b'),
  AI: $t('k_435ec665'),
};
